import { StopTravelStatus, SystemState } from '../redux/type';
import * as AllTypes from '../redux/type';
import moment from 'moment';
import { message } from 'antd';
import {
  InterSectionException,
  STOP_ENUM,
  AlarmEventList,
  BOOT_ALARM,
} from './constant';
import { cloneDeep } from 'lodash';
import { Method } from '@/fetch/core/util';
import { request } from '@/fetch/core';
import { isNumber } from '@warehouse/utils';
export const isVehicleOnline = (vehicleState: SystemState | undefined) => {
  if (
    vehicleState != undefined &&
    vehicleState != SystemState.UNKNOWN &&
    vehicleState != SystemState.OFFLINE &&
    vehicleState != SystemState.CONNECTION_LOST
  ) {
    return true;
  }
  return false;
};
export const mqttPublish = (topic: string, data: string) => {
  (window as any).mqttClient?.publish(topic, data);
};
// eslint-disable-next-line require-jsdoc
export function stringToEnum<T>(
  enumObj: T,
  strKey: string
): T[keyof T] | undefined {
  if (strKey in enumObj) {
    const key: keyof typeof enumObj = strKey as keyof typeof enumObj;
    return enumObj[key];
  }
  return undefined;
}

export function translatorEnum(keyName: string, value: string) {
  if (!value) {
    return null;
  }
  const enumTranslator = JSON.parse(
    localStorage.getItem('ENUM_LIST_MAP') || '{}'
  );
  const source = enumTranslator[keyName];
  return (
    source?.find((i: { code: string; name: string }) => i.code === value)
      ?.name || value
  );
}
export const formatStationList = (realtimeInfo: any, schedule: any) => {
  const stop = (schedule && schedule.stopList) || [];
  // 从SINGLE_VEHICLE接口获取实时推送的当前停靠点完成里程
  const finishedMileage =
    realtimeInfo && realtimeInfo.currentStopFinishedMileage;
  const stopList: any[] = [];
  stop.forEach((item: any, index: number) => {
    let percent = 0;
    let stopStatus = AllTypes.StopStatus.UNARRIVED;
    if (
      [
        StopTravelStatus.STAY,
        StopTravelStatus.DEPART,
        StopTravelStatus.SKIP,
      ].includes(item.travelStatus)
    ) {
      percent = 100;
    } else if (
      [StopTravelStatus.START].includes(item.travelStatus) &&
      finishedMileage
    ) {
      percent =
        (finishedMileage / item.globalMileage) * 100 >= 100
          ? 100
          : (finishedMileage / item.globalMileage) * 100;
    } else {
      percent = 0;
    }

    if (percent < 0) {
      percent = 0;
    }

    // 停靠点归类：装在点、卸载点、停靠点，为显示不同hover效果
    if (item.travelStatus === StopTravelStatus.STAY) {
      stopStatus = AllTypes.StopStatus.CURRENT;
    } else if (item.travelStatus === StopTravelStatus.DEPART) {
      stopStatus = AllTypes.StopStatus.ARRIVED;
    } else if (item.travelStatus === StopTravelStatus.SKIP) {
      // 跳过的点与上一个点保持一致
      if (index > 0 && index < stop.length) {
        // 起点和终点之间的点
        const preStop = stop[index - 1] || {};
        if (
          [StopTravelStatus.DEPART, StopTravelStatus.SKIP].includes(
            <StopTravelStatus>preStop.travelStatus
          )
        ) {
          stopStatus = AllTypes.StopStatus.ARRIVED;
        } else {
          stopStatus = AllTypes.StopStatus.UNARRIVED;
        }
      }
    } else {
      stopStatus = AllTypes.StopStatus.UNARRIVED;
    }
    const stopItem: any = {
      id: item.id,
      title: item.name,
      estDepartTime:
        item.estDepartTime && moment(item.estDepartTime).format('HH:mm'),
      time:
        item &&
        item.arrivedTime &&
        item.waitingTime &&
        item.waitingTime * 60000 - (new Date().getTime() - item.arrivedTime),
      stopStatus,
      stopAction: item.stopAction,
      goalId: item.goalId,
      isArrived: item.travelStatus === StopTravelStatus.STAY, // 当前点的travelStatus的为stay状态是,判断为已到达
      travelStatus: item.travelStatus,
      percent,
      globalMileage: item.globalMileage,
      arrivedTime: item.arrivedTime,
      departTime: item.departTime,
      waitingTime: item.waitingTime,
    };
    stopList.push(stopItem);
  });
  return stopList;
};

export const transTimeStamp = (delta: number) => {
  if (delta < 60000) {
    return '<1min';
  } else if (delta >= 60000 && delta < 3600000) {
    return `${Math.floor(delta / 60000)}min`;
  } else if (delta >= 3600000 && delta < 86400000) {
    const t1 = Math.floor(delta / 3600000);
    const t2 = Math.floor((delta % 3600000) / 60000);
    return `${t1}h${t2}min`;
  }

  return '24h+';
};

export const transCockpitWorkTime = (delta: number) => {
  if (!isNumber(delta)) {
    return null;
  }
  if (delta < 60000) {
    return '0分钟';
  } else if (delta >= 60000 && delta < 3600000) {
    return `${Math.floor(delta / 60000)}分钟`;
  } else {
    const t1 = Math.floor(delta / 3600000);
    const t2 = Math.floor((delta % 3600000) / 60000);
    return `${t1}小时${t2}分钟`;
  }
};

export const transIssueDurationTime = (delta: number) => {
  if (delta < 60000) {
    return `${Math.floor(delta / 1000)}秒`;
  } else if (delta >= 60000 && delta < 3600000) {
    const t1 = Math.floor(delta / 60000);
    let t2: any = Math.floor((delta % 60000) / 1000);
    t2 = t2 < 10 ? `0${t2}` : t2;
    return `${t1}分钟${t2}秒`;
  } else {
    const t1 = Math.floor(delta / 3600000);
    const t2 = Math.floor((delta % 3600000) / 60000);
    return `${t1}小时${t2}分钟`;
  }
};
export const transIssueTime = (delta: number) => {
  if (delta < 60) {
    return `${Math.floor(delta)}秒`;
  } else if (delta >= 60 && delta < 3600) {
    const t1 = Math.floor(delta / 60);
    let t2: any = Math.floor(delta % 60);
    t2 = t2 < 10 ? `0${t2}` : t2;
    return `${t1}分钟${t2}秒`;
  } else {
    const t1 = Math.floor(delta / 3600);
    const t2 = Math.floor((delta % 3600) / 60);
    return `${t1}小时${t2}分钟`;
  }
};

export const timeRules = (timeStamp: any) => {
  if (!timeStamp) {
    return;
  }
  const result: any = {};
  const now = Date.now();
  const startTime = new Date(timeStamp);
  const delta = now - startTime.getTime();
  const timeStr = transTimeStamp(delta);
  result.timeStr = timeStr;
  const rulesMap = new Map([
    ['0,60000', '#fff'],
    ['60000,600000', '#fff'],
    ['600000,3600000', '#FF463A'],
    ['3600000,86400000', '#FF463A'],
    ['86400000,9999999999999999', '#FF463A'],
  ]);

  for (const [key, value] of rulesMap) {
    const temp = key.split(',');
    const left = parseInt(temp[0]);
    const right = parseInt(temp[1]);
    if (delta >= left && delta < right) {
      result.color = value;
      break;
    }
  }

  return result;
};

export const handleSortAlarmEvant = (source: any, sortType: number) => {
  if (sortType == 1) {
    const _alarmListMap: any = cloneDeep(AlarmEventList);
    source?.forEach((item: any) => {
      let index = _alarmListMap.findIndex(
        (i: any) => i.value === item.alarmEvent
      );
      if (STOP_ENUM.includes(item.alarmEvent)) {
        index = 5;
      }
      if (InterSectionException.includes(item.alarmEvent)) {
        index = 4;
      }
      if (BOOT_ALARM.includes(item.alarmEvent)) {
        index = 3;
      }
      if (index > -1) {
        if (!_alarmListMap[index]?.list) {
          _alarmListMap[index].list = [];
        }
        _alarmListMap[index]?.list?.push(item);
      }
    });

    return _alarmListMap;
  }

  // 按时间排序
  return source?.sort((a: any, b: any) => {
    const t1 = new Date(a.reportTime);
    const t2 = new Date(b.reportTime);
    return t1.getTime() - t2.getTime();
  });
};

export const translateMileageNum = (mileage: any) => {
  if (typeof mileage !== 'number') {
    return 0;
  }
  return (mileage / 1000).toFixed(2);
};

// 行为埋点tag
export const clstagStr = (logId: string) => {
  return `h|keycount|${logId}`;
};

// 自定义行为埋点事件
export const analyzeLog = (key: string, value: string) => {
  try {
    (window as any).log('jdxmonitor', key, value);
  } catch (e) {
    console.log(e);
  }
};

// 获取通用级联下拉列表
export const fetchCommonCategory = async (keyList: string[]) => {
  const param: RequestOptions = {
    method: Method.POST,
    path: '/monitor/web/enum/get_category_list',
    body: {
      keyList: keyList,
    },
  };

  return request(param);
};

export const formatTimeStamp = (timeStamp: any) => {
  const now = new Date(timeStamp);
  return now.toTimeString().substr(0, 8);
};

export const formatCurDateTime = (
  currentDateTime: Date,
  onlyTime?: boolean
) => {
  const year = currentDateTime.getFullYear();
  const month = String(currentDateTime.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
  const day = String(currentDateTime.getDate()).padStart(2, '0');
  const hours = String(currentDateTime.getHours()).padStart(2, '0');
  const minutes = String(currentDateTime.getMinutes()).padStart(2, '0');
  const seconds = String(currentDateTime.getSeconds()).padStart(2, '0');
  if (onlyTime) {
    return `${hours}:${minutes}:${seconds}`;
  }
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatDuration = (startTime: string, endTime: string) => {
  if (endTime) {
    return moment(moment(endTime).diff(moment(startTime)))
      .utc()
      .format('HH:mm:ss');
  } else {
    if (moment(startTime).isBefore(moment().startOf('day'))) {
      const tPlusOneTime = moment(startTime).add(1, 'd').startOf('day');
      return moment(tPlusOneTime.diff(moment(startTime)))
        .utc()
        .format('HH:mm:ss');
    } else {
      return moment(moment().diff(moment(startTime)))
        .utc()
        .format('HH:mm:ss');
    }
  }
};

export const formatCommonCategory = (categoryList: any[]): any[] => {
  const res: any = [];
  categoryList &&
    categoryList.forEach((category: any, index: number) => {
      !category.child && res.push([category.id]);
      category.child &&
        category.child.forEach((item: any, idx: number) => {
          res.push([category.id, item.id]);
        });
    });
  return res;
};

export const formatCommonCategoryChild = (tempArr: any[]) => {
  const res: any = [];
  tempArr &&
    tempArr.forEach((item: any, index: number) => {
      res.push(item[1]);
    });

  return res;
};

export const translateSceneSignal = (data: number) => {
  let mapStr = '';
  const SCENE_SIGNAL: any = new Map([
    ['0,2.0', '定位偏移'],
    ['2.0,3.0', '定位准确性差'],
    ['3.0,3.5', '定位准确性较差'],
    ['3.5,4.5', '定位较准确'],
    ['4.5,5.0', '定位准确'],
  ]);

  if (data == 0) {
    return '定位偏移';
  }
  for (const [key, value] of SCENE_SIGNAL) {
    const limit = key?.split(',');
    const [left, right] = limit;
    if (data > left && data <= right) {
      mapStr = value;
      break;
    }
  }

  return mapStr;
};

export const formatJiraNo = (jiraNo: string | undefined): string => {
  let res = '';
  if (!jiraNo || jiraNo == '') {
    return '';
  }
  const temp = jiraNo.split('');
  res = temp.slice(jiraNo.length - 7, jiraNo.length).join('');
  return res;
};

export const showMsg = ({
  msg,
  type,
  duration,
  onClose,
}: {
  msg: string;
  type: 'success' | 'error' | 'info' | 'warning' | 'loading';
  duration?: number;
  onClose?: AnyFunc;
}) => {
  switch (type) {
    case 'success':
      message.success(msg, duration, onClose);
      break;
    case 'error':
      message.error(msg, duration, onClose);
      break;
    case 'info':
      message.info(msg, duration, onClose);
      break;
    case 'warning':
      message.success(msg, duration, onClose);
      break;
    case 'loading':
      message.success(msg, duration, onClose);
      break;
  }
};

export const isNumberPro = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'number') return !isNaN(value);
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    return !isNaN(parsed) && isFinite(parsed);
  }
  return false;
};

/**
 * 将HTTP URL转换为HTTPS URL，确保下载链接的安全性
 *
 * @param {string} [url]
 * @return {*}  {string}
 */
export const transferHttpUrlToHttpsUrl = (url?: string): string => {
  if (!url) {
    return '';
  }
  return url.startsWith('http:') ? url.replace(/^http:/, 'https:') : url;
};

/**
 * 递归下载多个文件
 * 利用a标签下载（遍历window.open会出现仅下载第一个文件的情况）
 *
 * @param {(Array<string | null | undefined>)} urls
 * @param {number} [delay=100]
 * @return {*}  {Promise<void>}
 */
export const downloadUrlsSerially = (
  urls: Array<string | null | undefined>,
  delay = 100
): Promise<void> => {
  const validUrls = urls.filter((url): url is string => !!url);

  return new Promise((resolve) => {
    const downloadNext = (fileList: string[]) => {
      if (!fileList.length) {
        resolve();
        return;
      }

      const url = fileList.shift();
      if (!url) {
        downloadNext(fileList);
        return;
      }

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', url);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        downloadNext(fileList);
      }, delay);
    };

    downloadNext([...validUrls]);
  });
};

export const convertSpeedMsToKmh = (
  speedMs: any,
  numberOfDecimalPlaces?: number,
  systemState?: string
): string => {
  if (isNumberPro(speedMs)) {
    if (systemState === 'OFFLINE') {
      return '--';
    }
    if (Number(speedMs) === 0) {
      return '0 km/h';
    }
    if (numberOfDecimalPlaces !== undefined) {
      return `${(speedMs * 3.6).toFixed(numberOfDecimalPlaces)} km/h`;
    }
    return `${speedMs * 3.6} km/h`;
  } else {
    return '--';
  }
};

/**
 * 判断一个值是否为“异常值”。
 * 异常值的定义：undefined、null、NaN（仅限 number 类型的 NaN）。
 * @param value 任何待检测的值
 * @returns 若为 undefined/null/NaN 返回 true，否则返回 false
 */
export function isAbnormalValue(value: any): boolean {
  // 注意：Number.isNaN 只有在参数为 number 且为 NaN 时才返回 true
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'number' && Number.isNaN(value))
  );
}

/**
 * 跳转到 Jira/Bug 平台
 * @param bugCode bug 编码，以 'B' 开头跳转星云 Bug 平台，否则跳转 Jira
 */
export const goJiraPlatform = (bugCode: string): void => {
  if (bugCode.startsWith('B')) {
    window.open(`http://xingyun.jd.com/test-manage/jbug/${formatJiraNo(bugCode)}`);
  } else {
    window.open(`http://jira.jd.com/browse/${bugCode}`);
  }
};
